export function getTeacherNavSections() {
  return [
    {
      label: '工作台',
      items: [
        { name: '教师首页', path: '/', icon: 'home' },
        { name: '功能导航', path: '/teacher/nav', icon: 'nav' },
        { name: '班牌状态', path: '/teacher/board', icon: 'board' },
        { name: '通知发布', path: '/teacher/notices', icon: 'bell' }
      ]
    },
    {
      label: '班级管理',
      items: [
        { name: '班级学生', path: '/teacher/students', icon: 'class', exact: true },
        {
          name: '学生人脸管理',
          path: '/teacher/students/face-manage',
          icon: 'class',
          exact: true,
          matchPrefixes: ['/teacher/students/face-manage', '/teacher/students/face-enrollment'],
          headTeacherOnly: true
        },
        { name: '班级荣誉', path: '/teacher/class-honors', icon: 'star' }
      ]
    },
    {
      label: '学生事务',
      items: [
        { name: '请假管理', path: '/teacher/leave', icon: 'leave' },
        {
          name: '留校管理',
          path: '/teacher/stay-school',
          icon: 'leave',
          headTeacherOnly: true,
          excludePaths: ['/teacher/stay-school/attendance-config', '/teacher/stay-school/attendance', '/teacher/stay-school/attendance-records']
        },
        { name: '取物管理', path: '/teacher/pickup', icon: 'leave' },
        { name: '考勤查看', path: '/teacher/attendance/records', icon: 'attendance' },
        { name: '家校沟通', path: '/teacher/home-school', icon: 'chat', headTeacherOnly: true }
      ]
    },
    {
      label: '德育管理',
      items: [
        { name: '德育记录', path: '/teacher/moral/records', icon: 'chart', exact: true, matchPrefixes: ['/teacher/moral/records'] },
        { name: '德育评价', path: '/teacher/moral', icon: 'star', exact: true },
        { name: '德育项目', path: '/teacher/moral/items', icon: 'score', exact: true, matchPrefixes: ['/teacher/moral/items'] }
      ]
    },
    {
      label: '教学教务',
      items: [
        { name: '班级课表', path: '/teacher/schedule', icon: 'schedule' },
        { name: '通校生时间配置', path: '/teacher/commuters', icon: 'class' },
        { name: '留校生考勤', path: '/teacher/stay-school/attendance', icon: 'attendance' }
      ]
    },
    {
      label: '宿舍服务',
      items: [
        { name: '宿舍查看', path: '/teacher/dorm', icon: 'dorm', exact: true },
        { name: '寝室考勤查看', path: '/teacher/dorm/attendance', icon: 'attendance', matchPrefixes: ['/teacher/dorm/attendance'] },
        {
          name: '留校考勤记录',
          path: '/teacher/stay-school/attendance-records',
          icon: 'attendance',
          headTeacherOnly: true,
          matchPrefixes: ['/teacher/stay-school/attendance-records']
        }
      ]
    }
  ]
}
